import { GamePage } from '../c/Game';
export default GamePage;



// WEBPACK FOOTER //
// ./src/p/Game.js